import { isSameDay, parseISO } from 'date-fns'

/* 
  TODO: Avaliar com o time no fórum de front-end o uso de JSDocs para documentar partes mais complexas do projeto
  para facilitar o entendimento e a manutenção do código
*/

/**
* Compara as datas disponíveis com as datas das próximas reservas. Se a data de uma reserva
* corresponder a uma data disponível, a chave correspondente será substituída pela string completa
* da data da reserva. As chaves não correspondentes são mantidas.
* 
* @param availabilities - O array de disponibilidades para ser comparado.
* @param nextReservationEventsData - O array de datas das próximas reservas.
* @returns O array de disponibilidades com as chaves substituídas pelas datas das reservas correspondentes.
*/

type AvailabilitiesFormatted = {
  [key: string]: string[]
};

export const compareAndReplaceDates = (
  availabilities: AvailabilitiesFormatted[],
  nextReservationEventsData: string[]
): AvailabilitiesFormatted[] => {

  return availabilities.map(availability => {
    const [dateKey, times] = Object.entries(availability)[0]

    const matchingReservation = nextReservationEventsData.find(reservationDateStr => {
      const availabilityDate = parseISO(dateKey)
      const reservationDate = parseISO(reservationDateStr)
    
      return isSameDay(availabilityDate, reservationDate)
    })

    if (matchingReservation) {
      return { [matchingReservation]: times }
    } 

    return availability
  })
}
